import axios from 'axios';

export default {
  fetchFieldVisibility(_, domain) {
    return axios.get('/fields', { params: { domain } });
  },
  saveFieldVisibility({ commit }, { domain, fields }) {
    return axios.post('/fields', { fields })
      .then(() => {
        const hiddenFields = fields.reduce((acc, field) => {
          if (!field.isDisplayed) {
            acc.push(field.labelCode);
          }

          return acc;
        }, []);

        commit('app/setHiddenFields', { fields: hiddenFields, domain }, { root: true });
      });
  },
};
